import { render, staticRenderFns } from "./AnnouncementDialog.vue?vue&type=template&id=20129040&scoped=true"
import script from "./AnnouncementDialog.vue?vue&type=script&lang=js"
export * from "./AnnouncementDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20129040",
  null
  
)

export default component.exports